import React, { Activity, useCallback, useEffect, useRef, useState } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { AppText } from '@/components/AppText';
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { Link } from 'expo-router';
import Footer from '@/components/Footer';
//import YoutubePlayer from "react-native-youtube-iframe";
import { Video, IVideo } from '@/components/Video';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import { Image } from 'expo-image';
import { CommunityMembership, UNKNOWN_COMMUNITY_MEMBERSHIP } from "@/types/community_membership";
import { UNKNOWN_PROFILE } from "@/types/profile";
import { Gender, UNKNOWN_USER_INFO } from "@/types/user_info";
import { useFocusEffect, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { RabblSearchResult } from "@/components/RabblSearchResult";
import { CustomDivider } from "@/components/CustomDivider";
import { ExternalLink } from '@/components/ExternalLink';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
  },
  center: {
    alignItems: 'center',
    width: '100%',
  },
  flexRow: {
    flexDirection: 'row',
    gap: 5,
    alignItems: 'center',
  },
  flexRow2: {
    flexDirection: 'row',
    gap: 5,
    alignItems: 'center',
  },
  rabblsWrapperWeb: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 50,
    paddingTop: 10,
  },
  rabblsWrapperApp: {
    alignItems: 'center',
    gap: 50,
    paddingTop: 30,
  },
  bottomRow: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 50,
    flexDirection: "row",
    gap: 10,
  },
});

const kevg : CommunityMembership = Object.assign({}, UNKNOWN_COMMUNITY_MEMBERSHIP, {
  user_info: Object.assign({}, UNKNOWN_USER_INFO, {
    age_year: 1984,
    age_month: 6,
    gender: Gender.GENDER_MAN,
    location_name: "Texas",
  }),
});

export default function Aesthetic() {
  const highlighted_communities2_kevg = useSelector((state: RootState) => state.user.highlighted_communities2_kevg);
  const video1 = useRef<IVideo>(null);
  const video2 = useRef<IVideo>(null);

  useFocusEffect(
    useCallback(() => {
      return () => {
        video1.current?.pause();
        video2.current?.pause();
      };
    }, [])
  );

  return (
    <BasicScrollView center={false}>
      <Meta title={"Aesthetic"} />
      <View style={styles.flexRow}>
        <AppText>The internet has become a bit too  {AppUtilities.stringToFullWidth("bland")}  and sterile, lacking personality.</AppText>
        <Image source={require('@/assets/images/minis/robot5.gif')} style={{ width: 25, height: 34 }} />
        {/*
        <Image source={require('@/assets/images/minis/punchground.gif')} style={{ width: 20, height: 20 }} />
        */}
        {/*
        <Image source={require('@/assets/images/minis/bleh.gif')} style={{ width: 29, height: 14 }} />
        */}
      </View>
        
      <View style={styles.flexRow2}>
        <AppText>The aesthetic here is  <CustomText>dark optimism</CustomText> : vaporwave & cyberpunk -- things haven't lived up to their potential -- mixed with optimism and かわいい -- there's light to be found.</AppText>
        <Image source={require('@/assets/images/minis/chasebutterfly.gif')} style={{ width: 55, height: 22 }} />
      </View>

      {/*
      <View style={styles.flexRow}>
        <AppText>Add some personality to the internet by hand-building your own free website at <Link href="https://neocities.org/" target="_blank" style={CustomTextStyles.link}>Neocities</Link> or <Link href="https://nekoweb.org/" target="_blank" style={CustomTextStyles.link}>Nekoweb</Link>.</AppText>
        <Image source={require('@/assets/images/minis/neocities.png')} style={{ width: 20, height: 20 }} />
        <Image source={require('@/assets/images/minis/nekoweb.png')} style={{ width: 20, height: 20 }} />
      </View>
      */}

      <View style={styles.center}>
        <Video
          source={"/videos/vE3NiCdfHpU.mp4"}
          autoplay={false}
          ref={video1}
          height={170}
        />
      </View>

      <View style={styles.flexRow2}>
        <AppText>Vaporwave, early web, cyberpunk and glitch are all <ExternalLink href="https://www.youtube.com/watch?v=7mFJdOsjJ0ka" target="_blank" style={CustomTextStyles.link}>a bit stale</ExternalLink> but the inspiration for our aesthetic is <ExternalLink href="https://blog.neocities.org/blog/2013/05/28/making-the-web-fun-again" target="_blank" style={CustomTextStyles.link}>not just nostalgia</ExternalLink>. It also gives us joy building Rabbl and we hope it gives you a smile.</AppText>
        <Image source={require('@/assets/images/minis/dog18.gif')} style={{ width: 30, height: 13 }} />
        {/*
        <Image source={require('@/assets/images/minis/christmas.gif')} style={{ width: 20, height: 20 }} />
        */}
      </View>

      <View style={styles.flexRow2}>
        <AppText>My name's Kevin and I'm the founder of Rabbl. Despite the whimsical aesthetic, we're serious about this app and helping people find each other. I've got over 20 years of corporate experience in coding and security.</AppText>
        <Image source={require('@/assets/images/minis/brain.gif')} style={{ width: 20, height: 20 }} />
      </View>

      <View style={AppConstants.STYLES.padding3} />

      <Activity mode={highlighted_communities2_kevg && highlighted_communities2_kevg.length > 0 ? 'visible' : 'hidden'}>
      
        <CustomDivider fullWidth={true} />

        <View style={AppConstants.STYLES.padding1} />

        <View style={styles.flexRow}>
          <AppText>Kevin's single and ladies can find him on these Rabbls:</AppText>
        </View>
        
        <View style={ AppUtilities.isWeb() ? styles.rabblsWrapperWeb : styles.rabblsWrapperApp }>
          {highlighted_communities2_kevg.map((candm) => (
            <View key={candm.community.id}>
              <RabblSearchResult
                community={candm.community}
                community_membership={candm.community_membership}
                communityNameOverTop={true}
                communityNameUnderneath={false}
                communityMembershipLink={true}
              />
            </View>
          ))}
        </View>

        <View style={AppConstants.STYLES.padding10} />
      </Activity>

      <CustomDivider fullWidth={true} />

      <View style={AppConstants.STYLES.padding5}></View>

      <View style={styles.center}>
        <Video
          source={"/videos/cBTz_ugh_b4.mp4"}
          autoplay={false}
          ref={video2}
          showLink={false}
          height={127}
        />
      </View>

      <View style={styles.bottomRow}>
        <AppText>Lovingly hand-crafted without AI.</AppText>
        <Image source={require('@/assets/images/minis/heart11.gif')} style={{ width: 20, height: 20 }} />
      </View>

      <Footer />
    </BasicScrollView>
  );
}
